/**
 * Detects hover intent before triggering hover action
 * @param {object} element DOM element
 * @param {*} callbackIn Mouseenter callback function
 * @param {*} callbackOut Mouseout callback function
 * @param {int} delay Hover period in milliseconds
 */
function hoverIntent(element, callbackIn, callbackOut, delay = 200) {
  let timer;

  element.addEventListener("mouseenter", () => {
    timer = setTimeout(() => {
      callbackIn();
    }, delay);
  });

  element.addEventListener("mouseleave", () => {
    clearTimeout(timer);
    callbackOut();
  });
}

export { hoverIntent };
